/**
 * Create an object like {'searchParams': 'value'}
 * @param {string[]} paramsNames -
 * @param {string[] | undefined} paramsValues -
 * @return {undefined|Object<string, string>}
 */
function createMapParams(paramsNames, paramsValues) {
    const paramsMap = {};
    if (!paramsNames || !paramsValues || paramsValues.length === 0 || paramsNames.length === 0) return {args: paramsValues}; // TODO: remove args asap
    return paramsNames.reduce((acc, paramName, index) => {
        acc[paramName] = paramsValues[index];
        return acc;
    }, paramsMap);
}
export default createMapParams;
